import { useEffect, useState } from 'react'
import { getExperimentVariant } from '@/utils/experimentClient'
import { NavbarButtonId } from '@/scenes/Editor/components/Navbar/navbarConfig'

const EXPERIMENT_KEY = 'create_cta_button-v1'

/**
 * 'create_cta_button-v1' Amplitude Experiment: control is the existing grey
 * 'Try Premium' CTA, treatment swaps in the orange one on the create page.
 */
export function useCreateCtaButtonExperiment(): NavbarButtonId {
  const [buttonId, setButtonId] = useState<NavbarButtonId>('tryPremium')

  useEffect(() => {
    let cancelled = false
    getExperimentVariant(EXPERIMENT_KEY).then(value => {
      if (!cancelled && value === EXPERIMENT_KEY) setButtonId('tryPremiumOrange')
    })
    return () => { cancelled = true }
  }, [])

  return buttonId
}
